module.exports = __webpack_public_path__ + "img/fcf.a2786164.svg";